import { PLUGIN_SCRIPT_ONLY_DISPLAY_OPTIONS } from '../constants/embedOptions'
import type { PluginPublicCfg } from '../types/embedSettings'

/**
 * The labels of the cfg's display options that the No-Script code can't
 * carry, in the builder's order. Empty when the No-Script code carries all.
 */
export const scriptOnlyDisplayOptions = (cfg: PluginPublicCfg): string[] =>
  PLUGIN_SCRIPT_ONLY_DISPLAY_OPTIONS.filter(
    ({ key }) => cfg.display?.[key] !== undefined
  ).map(({ label }) => label)
